import { TReduxActions } from '../../../types/redux';
import { EUserStatusActionTypes } from '../../../actions/newAnswer';
import { EUserStatus } from '../../../types/newAnswer/userStatus';
import { TUserStatusRating } from '../../../types/newAnswer';
import { ENewAnswerForm } from '../../../actions/newAnswer/newAnswearAction';

export const defaultValue = {
  value: EUserStatus.Seeker,
};

export function userStatusReducer(
  state: TUserStatusRating = defaultValue,
  { type, payload }: TReduxActions,
): TUserStatusRating {
  if (type === EUserStatusActionTypes.SetUserStatus) {
    return {
      value: payload,
    };
  }

  if (type === ENewAnswerForm.Clear) {
    return defaultValue;
  }

  return state;
}
